import i18n from '@/locales';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import Vue from 'vue';
import { getCurrentInstance } from '@vue/composition-api';
import { Store } from 'vuex';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);
/**
 * 格式化输出时间 设置isBreak为true时（换行） 应该用v-html渲染
 * @param value // 时间戳
 * @param timezone // 时区
 * @param isBreak // 是否换行
 * @param format // 格式
 * @returns
 */
export const timeFormat = (value: string, timezone?: number, isBreak = false, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) return '';
    if (timezone !== undefined) {
        const time = dayjs(Number(value)).utcOffset(timezone).format(format);
        if (isBreak) {
            return `${time.replace(/\s/g, '<br/>')}`;
        }
        return time;
    }
    const time = dayjs(Number(value)).format(format);
    if (isBreak) {
        return `${time.replace(/\s/g, '<br/>')}`;
    }
    return time;
};

export const timeCustomFormat = (value: string, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!value) return '';

    const currentYear = dayjs().year();
    const targetYear = dayjs(Number(value)).year();
    if (format === 'MM-DD HH:mm:ss' && targetYear < currentYear) {
        return dayjs(Number(value)).format('YYYY-MM-DD HH:mm:ss');
    }

    return dayjs(Number(value)).format(format);
};

/**
 * 格式化unix时间 设置isBreak为true时（换行） 应该用v-html渲染
 * @param value // 时间戳
 * @param timezone // 时区
 * @param isBreak // 是否换行
 * @param format // 格式
 * @returns
 */
export const UnixTimeFormat = (value: string, timezone?: number, isBreak = false, format = 'YYYY-MM-DD HH:mm:ss') => timeFormat(`${value}000`, timezone, isBreak, format);

/**
 * 提取首字母，并大写
 * @param value
 * @returns
 */
export const initials = (value: string) => {
    if (!value) return '';
    return value.charAt(0).toUpperCase();
};

/**
 * 相对时间
 * @param val
 * @returns
 */
export const fromNow = (val: string, data?: any) => {
    try {
        if (!val || val === '0') {
            Vue.prototype.$log('SESSION_ERROR', 'FROM_NOW', { data: data || { time: val } });
        }
    } catch (e) {
        console.error(e);
    }
    val = val.toString().length < 13 ? `${val}000` : val;// 非13位毫秒级时间戳时，兼容为 毫秒级时间戳
    const time = dayjs(Number(val));
    if (time.isAfter(dayjs().startOf('day'))) {
        // 昨天之后，显示时分
        return time.format('HH:mm');
    }
    if (time.isAfter(dayjs().subtract(1, 'day').startOf('day'))) {
        // 昨天显示昨天
        return `${i18n.t('fromNow.yesterday')} ${time.format('HH:mm')}`;
    }
    // if (time.isAfter(dayjs().subtract(6, 'day').startOf('day'))) {
    //     return i18n.tc(`fromNow.week.${time.format('d')}`);
    // }

    // 不是本年度的
    if (time.isBefore(dayjs(), 'year')) {
        return time.format('YYYY/MM/DD');
    }
    return time.format('MM/DD HH:mm');
};
/**
 * 相对时间 for 帖子评论
 * @param val
 * @returns
 */
export const fromNowForComment = (val: string) => {
    val = val.toString().length < 13 ? `${val}000` : val;// 非13位毫秒级时间戳时，兼容为 毫秒级时间戳
    const time = dayjs(Number(val));
    if (time.isAfter(dayjs().startOf('day'))) {
        // 今天内，显示时分
        return `${i18n.t('components.SDatePicker.today')}${time.format('HH:mm')}`;
    }
    return time.format('YYYY-MM-DD HH:mm');
};

/**
 * 给时区补正号
 * @returns
 */
export const leftPadTimeZone = (val: string | number) => {
    if (Number(val) >= 0) {
        return `+${val}`;
    }
    return val;
};

/**
 * 从下载链接中提取原文件名
 * @param val
 * @returns
 */
export const originFileName = (val: string) => {
    let filename = val.split('/').pop() as string;
    if (filename.indexOf('_p_') > -1) {
        filename = filename?.split('_p_').pop() as string;
    }
    if (filename.indexOf('?') > -1) {
        filename = filename?.split('?').shift() as string;
    }
    try {
        filename = decodeURI(filename);
        filename = decodeURIComponent(filename);
    } catch (e) {
        // console.error(e);
    }
    return filename;
};

/**
 * 小数转为 百分率
 * @param val
 * @returns
 */
export const rate = (val: number) => `${(val * 100).toFixed(2)}%`;

/**
 * 根据时区格式化输出时间
 * @param val
 * @param timezone
 */
export const timeFormatByTimezone = (val: string, timezone?: string) => {
    const format = 'YYYY-MM-DD HH:mm:ss';
    if (!val) return '';
    return timezone ? dayjs(Number(val)).tz(timezone).format(format) : dayjs(Number(val)).format(format);
};

/**
 * 判断用户名称长度（加密）
 */
export const judgeNameLength = (target: string) => {
    let result = '';
    if (Number(target)) {
        result = target.replace(/\s+/g, '');
    }
    if (target.length <= 5) {
        result = `${target.substring(0, 1)}****${target.substring(target.length - 1)}`;
    } else if (target.length > 5 && target.length < 8) {
        result = `${target.substring(0, 2)}****${target.substring(target.length - 2)}`;
    } else {
        result = `${target.substring(0, 4)}****${target.substring(target.length - 3)}`;
    }
    return result;
};

export const informationHiddenFormat = (target: string, empty: string = '', store?: Store<any>) => {
    let currentStore = null;

    if (store) {
        currentStore = store;
    } else {
        const instance = getCurrentInstance();
        currentStore = instance?.proxy.$store;
    }

    if (!currentStore) return target || empty || '';

    const isHiddenPhone = currentStore.getters['user/isHiddenPhone'];
    const isHiddenEmail = currentStore.getters['user/isHiddenEmail'];

    const emailReg = /([A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,12})/g;
    const phoneRegex = /^[\s\d+\-()]*$/;
    if (target && target.indexOf('****') < 0) {
        if (isHiddenPhone && phoneRegex.test(target)) {
            return judgeNameLength(target.replace(/\s+/g, ''));
        }
        if (isHiddenEmail && emailReg.test(target)) {
            return judgeNameLength(target.replace(/\s+/g, ''));
        }
    }
    return target || empty || '';
};

/**
 * 完整时间显示 设置isBreak为true时（换行） 应该用v-html渲染
 */
export const fullTimeFormat = (value: string, isBreak = false) => {
    if (!value) return '-';
    if (isBreak) {
        return `${value.replace(/\s/g, '<br/>')}`;
    }
    return value;
};

/**
 * 部分时间显示 设置isBreak为true时（换行） 应该用v-html渲染
 */
export const partTimeFormat = (value: string, format = 'YYYY-MM-DD HH:mm', isBreak = false, ellipsis = '--') => {
    if (!Number(value || 0)) return ellipsis;
    const time = dayjs.unix(Number(value || 0)).format(format);
    if (isBreak) {
        return `${time.replace(/\s/g, '<br/>')}`;
    }
    return time;
};
